<!-- ********************************************************************************************* -->
<!-- * IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS * -->
<!-- * IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS IODAS * -->
<!-- ********************************************************************************************* -->

<div class="row mt-5">
  <div class="col-xl-2"></div>
  <div class="col-xl-8">
    <h4 class="text-secondary mb-3" id="importIodasTitle">Liste des logs des derniers imports IODAS</h4>
    <ng-container [ngTemplateOutlet]="logsTable" [ngTemplateOutletContext]="{ logs: iodasLogs }"> </ng-container>
  </div>
  <div class="col-xl-2"></div>
</div>

<!-- ********************************************************************************************* -->
<!-- * CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV C * -->
<!-- * CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV CSV C * -->
<!-- ********************************************************************************************* -->

<div class="row mt-5">
  <div class="col-xl-2"></div>
  <div class="col-xl-8">
    <h4 class="text-secondary mb-3" id="importCsvTitle">Imports CSV</h4>

    <div *appOnlyGroups="['ADMIN']" class="mb-3">
      <div *ngIf="importCsvForm">
        <form [formGroup]="importCsvForm" (ngSubmit)="onSubmit()" class="d-flex">
          <!-- File input -->
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              readonly="true"
              [class.is-invalid]="importCsvForm.controls?.fileName?.errors?.allowedType || (submitted && importCsvForm.controls.fileName.invalid)"
              formControlName="fileName"
            />
            <label class="btn btn-secondary input-group-text">
              <span class="cursor-pointer">
                Parcourir...
                <input (change)="onFileChange($event)" type="file" style="display: none" />
              </span>
            </label>
          </div>

          <!-- Submit button -->
          <button class="btn btn-primary ms-3" type="submit">Importer</button>
        </form>

        <div>
          <small *ngIf="submitted && importCsvForm.controls?.fileName?.errors?.required" class="form-text text-danger">
            Le document est requis
          </small>
          <small *ngIf="importCsvForm.controls?.fileName?.errors?.allowedType" class="form-text text-danger">
            Seuls les fichiers de type CSV sont acceptés
          </small>
        </div>
      </div>
    </div>

    <ng-container [ngTemplateOutlet]="logsTable" [ngTemplateOutletContext]="{ logs: csvLogs }"> </ng-container>
  </div>
  <div class="col-xl-2"></div>
</div>

<!-- ********************************************************************************************* -->
<!-- * TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS * -->
<!-- * TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS TPL-LOGS * -->
<!-- ********************************************************************************************* -->

<ng-template #logsTable let-logs="logs">
  <table class="table table-sm table-hover" aria-describedby="importCsvTitle">
    <thead class="text-primary bg-light">
      <tr>
        <th scope="col">Date de l'import</th>
        <th scope="col">Log</th>
        <th scope="col">Nb bénéficiaires</th>
      </tr>
    </thead>
    <tbody *ngIf="logs?.length">
      <tr *ngFor="let log of logs" target="_blank">
        <td>{{ log.logDate }}</td>
        <td>
          <a [routerLink]="null" (click)="download(log.id, log?.logName)">{{ log.logName }}</a>
        </td>
        <td>{{ log.logNbBenefs ?? '-' }}</td>
      </tr>
    </tbody>
    <tbody *ngIf="logs?.length == 0" class="">
      <tr>
        <td>Aucun fichier</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</ng-template>
